import { useTheme } from "@mui/material";
import EmailIcon from "assets/email.svg?react";
import WeChatIcon from "assets/socialmedia/wechat.svg?react";
import WhatsAppIcon from "assets/socialmedia/whatsapp-2.svg?react";
import ChatIcon from "@mui/icons-material/Chat";
import useIsMobile from "hooks/useIsMobile";
import { useEffect, useState } from "react";
import FloatingBox from "./FloatingBox";

type FloaterProps = {
  shouldShowFloater?: boolean;
  user?: {
    name?: string;
    email?: string;
  };
};

const Floater = ({ shouldShowFloater, user }: FloaterProps) => {
  const theme = useTheme();
  const [isChatReady, setIsChatReady] = useState(false);
  const isMobile = useIsMobile();

  const mobile = 971507772486;
  const text = "";

  useEffect(() => {
    const initChat = async () => {
      const { initCrispChat } = await import("utils/crispChat");
      initCrispChat();

      const interval = setInterval(() => {
        if (window.$crisp) {
          setIsChatReady(true);
          clearInterval(interval);
        }
      }, 500);

      return () => clearInterval(interval);
    };

    initChat();
  }, [user]);

  const baseButtonConfig = {
    buttonColor: "#2dbb00",
    backgroundColor: theme.palette.primary.main,
    size: "small" as const,
  };

  const buttons = [
    {
      icon: ChatIcon,
      name: "Chat with us",
      onClick: () => {
        import("utils/crispChat").then(({ openCrispChat }) =>
          openCrispChat(user)
        );
      },
      disabled: !isChatReady,
      ...baseButtonConfig,
    },
    {
      icon: WhatsAppIcon,
      name: "WhatsApp",
      onClick: () =>
        window.open(
          `https://api.whatsapp.com/send?phone=${mobile}&text=${text}`,
          "_blank"
        ),
      ...baseButtonConfig,
    },
    {
      icon: WeChatIcon,
      name: "WeChat",
      onClick: () =>
        window.open(`https://u.wechat.com/kDyq4o-M74ywG1XjRwskHqQ`, "_blank"),
      ...baseButtonConfig,
    },
    {
      icon: EmailIcon,
      name: "Email",
      onClick: () => window.open(`mailto:sales@incomlend.com`, "_blank"),
      ...baseButtonConfig,
    },
  ];

  return shouldShowFloater ? (
    <FloatingBox
      data={buttons}
      style={
        isMobile
          ? { bottom: "15vh", right: 5, margin: 10 }
          : { bottom: "15vh", right: 15, margin: 14 }
      }
    />
  ) : null;
};

export default Floater;
